import { commonUtils } from './common_utils';

export const counters = {
    getRestApiUrl() {
        return commonUtils.getAppObject().data('rest-api-public-url');
    },
    getRestApiVertical() {
        return commonUtils.getAppObject().data('rest-api-vertical');
    },
    incrementByType(type) {
        new Image().src = `${this.getRestApiUrl()}/counter/${this.getRestApiVertical()}?type=${type}&time=${Date.now()}`;
    },
    incrementByAdId(type, adId, common) {
        const commonFlag = common || 'N';
        if (adId > 0) {
            new Image().src = `${this.getRestApiUrl()}/counter/${this.getRestApiVertical()}?type=${type}&id=${adId}&common=${commonFlag}&time=${Date.now()}`;
        }
    },
    incrementForShowcase(adId, idShowcase) {
        new Image().src = `${this.getRestApiUrl()}/counter/${this.getRestApiVertical()}?type=showcase-view&id=${adId}&idShowcase=${idShowcase}&time=${Date.now()}`;
    },
    incrementForUpsell(adId) {
        new Image().src = `${this.getRestApiUrl()}/counter/${this.getRestApiVertical()}?type=upsale-view&id=${adId}&time=${Date.now()}`;
    },
    incrementForHighlight(adId) {
        new Image().src = `${this.getRestApiUrl()}/counter/${this.getRestApiVertical()}?type=highlight-view&id=${adId}&time=${Date.now()}`;
    },
    adDetailCallCount(adId, postedBy) {
        this.incrementByAdId('vif-phone-mobile', adId);
        this.incrementByType(`phone-click-${postedBy}`);
    },
};

// Event delegation handlers for counter actions
$(document).on('click', '[data-action-call-count]', function () {
    counters.adDetailCallCount($(this).data('action-call-count'), $(this).data('call-posted-by'));
});

$(document).on('click', '[data-action-counter-type]', function () {
    counters.incrementByType($(this).data('action-counter-type'));
});
